export default "__VITE_ASSET__ypp8G8RB__"